import React, { FC } from "react";
import "./profileDisplayPicture.scss";
interface ProfileDisplayPictureProps {
  defaultValue: string;
}
const ProfileDisplayPicture: FC<ProfileDisplayPictureProps> = ({
  defaultValue,
}) => {
  return (
    <div className="profile-dp__container">
      <img className="profile-dp__image" src={defaultValue} />
      <div className="profile-dp__remove">Remove</div>
    </div>
  );
};
export default ProfileDisplayPicture;
